export default "__VITE_ASSET__CSQgeDMZ__"